import React from 'react';
import { connect } from 'react-redux';
import Helpers from '../../helpers/AssetHelpers.js';
import * as skillsActions from '../../actions/skills.js';
import { Popup } from '@sekmet/react-magnific-popup';

class Skills extends React.Component {
  componentDidMount() {
    this.props.dispatch(skillsActions.loadSkills());
  }

  render() {
    const { skills, error } = this.props.skills;
    const loading = this.props.loading;

    if(loading.loading) { return <section id="skills" ref={this.props.innerRef} /> }
    if(error) { return "error" }

    const PopupConfig = {
      type:'inline',
      fixedContentPos: false,
      removalDelay: 200,
      showCloseBtn: false,
      mainClass: 'mfp-fade'
    };

    return (

        <section id="skills" ref={this.props.innerRef}>
          <div className="row">
            <h2>Let's get technical</h2>
            {skills.map((skills_item =>
            <React.Fragment key={skills_item.id}>
              <h3>{skills_item.name}</h3>
              <ul>
              {skills_item.tech.map((skill_detail) =>
                <li key={skill_detail.id}>
                 <div className="anchor-item">
                    <div className="item-wrap">
                      <Popup href={`#skill-modal-${skill_detail.id}`} className="popup-anchor" config={PopupConfig} alt="title">
                        <img alt="" src={skill_detail.image.medium} />
                        <div className="overlay">
                          <div className="anchor-item-meta">
                            <h5>{skill_detail.name}</h5>
                            <p></p>
                          </div>
                        </div>
                        <div className="link-icon"><i className="icon-plus" /></div>
                      </Popup>
                    </div>
                  </div>
                  <div id={`skill-modal-${skill_detail.id}`} className="popup-modal mfp-hide">
                    <img className="scale-with-grid" src={skill_detail.image.thumb} alt="" />
                    <div className="description-box">
                      <h4>{skill_detail.name}</h4>
                      <p dangerouslySetInnerHTML={{__html: skill_detail.desc}}></p>
                      <span className="years-usage">{skill_detail.years} years of usage</span>
                    </div>
                    <div className="link-box">
                       <a className="popup-modal-dismiss">Close</a>
                    </div>
                  </div>
                </li>
              )}
              </ul>
            </React.Fragment>
            ))}
          </div>
        </section>
    );
  }
}

const mapStateToProps = state => ({
  ...state,
  skills: state.skills
});

export default connect(mapStateToProps, null, null, {withRef: true})(Skills);



// WEBPACK FOOTER //
// ./src/components/Skills/Skills.js